const pageNameKey = "taskbar";

export const taskbarEn = {
  [pageNameKey]: {
    errorFetchingTickets: "Error fetching tickets",
    errorPatchingTicket: "Error updating ticket status",
    homeIconAltText: "Go to homepage",
    addTicketIconAltText: "Add new support ticket",
    historyIconAltText: "View ticket history",
    sseErrorText:
      "The connection to the server is currently unstable, we might not be able to update the status of your tickets.",
  },
};

export const taskbarPtBr = {
  [pageNameKey]: {
    errorFetchingTickets: "Erro ao buscar tickets",
    errorPatchingTicket: "Erro ao atualizar o status do ticket",
    homeIconAltText: "Ir para a página inicial",
    addTicketIconAltText: "Adicionar novo ticket de suporte",
    historyIconAltText: "Ver histórico do ticket",
    sseErrorText:
      "A conexão com o servidor está instável no momento e talvez não consigamos atualizar o status dos seus tickets.",
  },
};

export const taskbarDe = {
  [pageNameKey]: {
    errorFetchingTickets: "Fehler beim Abrufen der Tickets",
    errorPatchingTicket: "Fehler beim Aktualisieren des Ticket-Status",
    homeIconAltText: "Zur Startseite gehen",
    addTicketIconAltText: "Neues Support-Ticket hinzufügen",
    historyIconAltText: "Ticketverlauf anzeigen",
    sseErrorText:
      "Die Verbindung zum Server ist derzeit instabil, wir können den Status Ihrer Tickets möglicherweise nicht aktualisieren.",
  },
};

export const taskbarZhHans = {
  [pageNameKey]: {
    errorFetchingTickets: "获取工单时出错",
    errorPatchingTicket: "更新工单状态时出错",
    homeIconAltText: "转到主页",
    addTicketIconAltText: "添加新的支持工单",
    historyIconAltText: "查看工单历史",
    sseErrorText: "当前与服务器的连接不稳定，我们可能无法更新您的工单状态。",
  },
};

export const taskbarIt = {
  [pageNameKey]: {
    errorFetchingTickets: "Errore durante il recupero dei ticket",
    errorPatchingTicket:
      "Errore durante l'aggiornamento dello stato del ticket",
    homeIconAltText: "Vai alla homepage",
    addTicketIconAltText: "Aggiungi un nuovo ticket di supporto",
    historyIconAltText: "Visualizza cronologia dei ticket",
    sseErrorText:
      "La connessione al server è attualmente instabile, potrebbe non essere possibile aggiornare lo stato dei ticket.",
  },
};

export const taskbarEs = {
  [pageNameKey]: {
    errorFetchingTickets: "Error al obtener los tickets",
    errorPatchingTicket: "Error al actualizar el estado del ticket",
    homeIconAltText: "Ir a la página principal",
    addTicketIconAltText: "Añadir nuevo ticket de soporte",
    historyIconAltText: "Ver historial de tickets",
    sseErrorText:
      "La conexión con el servidor es inestable en este momento; es posible que no podamos actualizar el estado de tus tickets.",
  },
};

export const taskbarNl = {
  [pageNameKey]: {
    addTicketIconAltText: "Nieuw supportticket toevoegen",
    errorFetchingTickets: "Fout bij het ophalen van tickets",
    errorPatchingTicket: "Fout bij het bewerken van de ticketstatus",
    historyIconAltText: "Ticketgeschiedenis weergeven",
    homeIconAltText: "Ga naar startpagina",
    sseErrorText:
      "De verbinding met de server is momenteel instabiel, mogelijk kunnen we de status van uw tickets niet bewerken.",
  },
};

export const taskbarTr = {
  [pageNameKey]: {
    addTicketIconAltText: "Yeni destek bileti ekle",
    errorFetchingTickets: "Biletler alınırken hata oluştu",
    errorPatchingTicket: "Bilet durumu güncellenirken hata oluştu",
    historyIconAltText: "Bilet geçmişini görüntüle",
    homeIconAltText: "Ana sayfaya git",
    sseErrorText:
      "Sunucuyla bağlantı şu anda kararsız, biletlerinizin durumunu güncelleyemeyebiliriz.",
  },
};
